<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.laboratorio"
        ref="RkmDataTable"
        sort-by="conectasusUnidadeNomeFantasia"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                @click="destroy(item)"
                authorize="destroy-web-service-laboratorio-cliente-laboratorio"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            laboratorio: this.getConectaSusRepository('webService.laboratorio.cliente.laboratorio'),
        }
    },
    data: () => ({
        fields: [
            {key: 'id', label: 'ID', name: 'laboratorio.id', searchable: true, sortable: true},
            {
                key: 'conectasusUnidadeNomeFantasia',
                label: 'Unidade (ConectaSUS)',
                name: 'conectasusUnidade.nomeFantasia',
                searchable: true,
                sortable: true
            },
            {
                key: 'conectasusInfraestruturaNome',
                label: 'Local de atendimento (ConectaSUS)',
                name: 'conectasusInfraestruturaNome',
                searchable: true,
                sortable: true
            },
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(item) {
            const destroy = () => this.repositories.laboratorio.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o laboratório?', destroy, this.handleError)
        },
    },
    mixins: [error, repository],
}
</script>